import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { ServiceType } from './servicetype.model';

@Injectable({
  providedIn: 'root'
})
export class ServicetypeService {



  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {

  }

  getAll(billerId: number, status: number) {
    return this.http.get<ServiceType[]>(this.global.APIURLV2 + "efbillerservicetype/get?billerId=" +
      billerId + "&status=" + status);
  }

  getById(id: number) {
    return this.http.get<ServiceType>(this.global.APIURLV2 + "efbillerservicetype/getbyid/" + id);
  }

  Update(serviceType: ServiceType) {
    return this.http.put(this.global.APIURLV2 + "efbillerservicetype/update", serviceType)
  }
}
